import React, { Component } from "react";
import { withTranslation } from "react-i18next";

class ButtonLoader extends Component {
  state = {
    loading: false
  };


  render() {
    const { loading } = this.state;

    return (
      <div >
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"></link>
        <button className="btn-address btn-disable" onClick={e=>(
          this.setState({ loading: true }),

           setTimeout(() => {
            this.setState({ loading: false })
          }, 3000)
        )} >

          {loading && <i class="fa fa-refresh fa-spin"></i>}
          {!loading && <span> { this.props.t('pages.paymentCard.buttons.buttonLoader.pay') } </span>}
        </button>
      </div>
    );
  }
}

export default withTranslation()(ButtonLoader)
